const ScrollThumb = ({ style, nodeRef, className, thumbStyle }) => (
  <div
    style={{ ...style, ...thumbStyle }}
    ref={nodeRef}
    className={className}
  />
);

ScrollThumb.defaultProps = {
  className: 'thumb-vertical',
  style: {
    position: 'relative',
    width: '100%',
    cursor: 'pointer',
  },
};

export default ScrollThumb;
